// Generative-UI renderer for raw SVG markup the agent authored directly.
// SVG can carry the same <script>/event-handler XSS vectors as HTML, so
// markup is routed through `sanitizeSvg` — the same DOMPurify wrapper module
// MarkdownText.tsx's HTML branch uses (`sanitizeHtml`), with an SVG-specific
// allowlist — before being rendered. Sanitize-then-render is non-negotiable
// here.

import { useMemo } from 'react';
import { Download } from 'lucide-react';
import { sanitizeSvg } from '@/shared/lib/sanitizeHtml';

const actionButtonClassName =
  'flex size-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground';

export function Svg({ markup }: { markup: string }) {
  const safeMarkup = useMemo(() => sanitizeSvg(markup), [markup]);

  function handleDownload() {
    const blob = new Blob([safeMarkup], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'image.svg';
    a.click();
    URL.revokeObjectURL(url);
    // TODO: hook a "share as persistent artifact" action here once a
    // download/artifact API exists for this content type.
  }

  return (
    <div className="my-2 rounded-lg border border-border bg-card p-3">
      <div className="mb-1 flex justify-end">
        <button type="button" aria-label="Download SVG" className={actionButtonClassName} onClick={handleDownload}>
          <Download className="size-4" />
        </button>
      </div>
      <div className="w-full" dangerouslySetInnerHTML={{ __html: safeMarkup }} />
    </div>
  );
}
